var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { attrs: { tag: "w-container" } },
    [
      _c(
        "w-row",
        [
          _c("w-col", { attrs: { xs: "12" } }, [
            _c("div", { staticClass: "breadcrumb" }, [_vm._v(" New Motd ")]),
          ]),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-card",
                [
                  _c(
                    "w-card-content",
                    [
                      _vm._l(_vm.languages, function (lang) {
                        return _c(
                          "w-row",
                          { key: lang },
                          [
                            _c(
                              "w-col",
                              [
                                _c("w-textarea", {
                                  attrs: { label: lang },
                                  model: {
                                    value: _vm.motd.translations[lang],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.motd.translations, lang, $$v)
                                    },
                                    expression: "motd.translations[lang]",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            [
                              _c("w-date-picker", {
                                attrs: { label: "Expiration Date" },
                                model: {
                                  value: _vm.motd.expirationDate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.motd, "expirationDate", $$v)
                                  },
                                  expression: "motd.expirationDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _c(
                    "w-card-actions",
                    [
                      _c(
                        "w-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.sendToCurrentlyActiveUsers()
                            },
                          },
                        },
                        [_vm._v(" Send to currently online users only ")]
                      ),
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.saveMotd()
                            },
                          },
                        },
                        [_vm._v(" Save ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }